import { render } from "./BarEditor.vue?vue&type=template&id=46d0a222&scoped=true&bindings={\"output\":\"data\",\"colors\":\"data\",\"parts\":\"data\",\"partsWithPercentage\":\"options\",\"deleteDataPoint\":\"options\",\"addDatapoint\":\"options\"}"
import script from "./BarEditor.vue?vue&type=script&lang=js"
export * from "./BarEditor.vue?vue&type=script&lang=js"

import "./BarEditor.vue?vue&type=style&index=0&id=46d0a222&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-46d0a222"

export default script